import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDate } from "../../shared/JVDate";
import { IBranchMastDropdown, IClientCompanyDropdown, ICompanyMastDropdown, ISkillCategoriesDropdown, ISubmissionStatusDropdown, ITeamsDropdown, IUsersDropdown } from "../../models/IDropdown";
import { JVDropdownInput } from "../../shared/JVDropdownInput";

export interface IPipelineFilter {
    fromDate?: Date | null,
    toDate?: Date | null,
    req_EndClient?: string | null,
    vendor_Company_ID?: number | null,
    vendor_Company?: IClientCompanyDropdown,
    subVendorID?: number | null,
    subVendor?: IClientCompanyDropdown,
    req_ID?: number | null | string,
    recruiter_ID?: number | null,
    status_Name?: string | null,
    team?: number | null,
    sm?: number | null,
    company?: number | null,
    branch?: number | null,
    companyType?: string | null,
    req_Category?: number | null,
    rejection?: number,
    rejection_Status?: number,
}

export const EmptyFilter: IPipelineFilter = {
    fromDate: new Date,
    toDate: new Date,
    req_EndClient: "",
    vendor_Company_ID: null,
    vendor_Company: { vendor_Company_ID: 0, vendor_Company_Name: "" },
    subVendorID: null,
    subVendor: { vendor_Company_ID: 0, vendor_Company_Name: "" },
    req_ID: "",
    recruiter_ID: null,
    status_Name: null,
    team: null,
    sm: null,
    company: null,
    branch: null,
    companyType: null,
    req_Category: null,
    rejection: 1,
}

interface Iprops {
    plFilter: IPipelineFilter,
    setPLFilter: (plFilter: IPipelineFilter) => void
}

export const Filter = (props: Iprops) => {
    const [recruiters, setRecruiters] = useState<Array<IUsersDropdown>>();
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();
    const [subVendorCompanies, setsubVendorCompanies] = useState<Array<IClientCompanyDropdown>>();
    const [submissionStatus, setSubmissionStatus] = useState<Array<ISubmissionStatusDropdown>>();
    const [team, setTeam] = useState<Array<ITeamsDropdown>>();
    const [sm, setSM] = useState<Array<IUsersDropdown>>();
    const [company, setCompany] = useState<Array<ICompanyMastDropdown>>();
    const [type, setType] = useState<Array<any>>();
    const [branch, setBranch] = useState<Array<IBranchMastDropdown>>();
    const [skillCategories, setSkillCategories] = useState<Array<ISkillCategoriesDropdown>>();


    const { control, handleSubmit, reset, watch } = useForm<IPipelineFilter>({
        defaultValues: props.plFilter,
        shouldFocusError: false
    });

    const loadRecruiters = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        } else if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersList", "GET", null, `user_Type=recruiter&${queryParameter}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setRecruiters(data);
        }
    }
    const loadSm = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        } else if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSM(data);
        }
    }
    const loadTeam = async (branch: number | null | undefined, company: number | null | undefined, type?: string) => {
        let queryParameter = null;
        if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        if (type && type != "" && type != "-- SELECT --") {
            if (type === "sales") queryParameter = "user_Type=sales&" + queryParameter;
            if (type === "recruiter") queryParameter = "user_Type=recruiter&" + queryParameter;
        }

        const response = await Fetch("Dropdown/filterTeamsList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<ITeamsDropdown> = await response.json();
            const emptyData = {
                team_ID: 0,
                team_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setTeam(data);
        }
    }


    const loadSkillCategories = async () => {
        const response = await Fetch("Dropdown/skillsCategories", "GET", null, null, null);
        if (response) {
            const data: Array<ISkillCategoriesDropdown> = await response.json();
            const emptyData = {
                req_CategoryID: 0,
                req_CategoryName: "-- SELECT --",
            };
            data.unshift(emptyData);
            setSkillCategories(data);
        }
    }

    const loadSubmissionStatus = async () => {
        const response = await Fetch("Dropdown/submissionStatus", "GET", null, null, null);
        if (response) {
            const data: Array<ISubmissionStatusDropdown> = await response.json();
            const emptyData = {
                status_ID: 0,
                status_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSubmissionStatus(data);
        }
    }

    const loadCompany = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompany(data);
        }
    }
    const loadBranch = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        const response = await Fetch("Dropdown/filterBranchList", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranch(data);
        }
    }
    const loadType = () => {

        const data = [
            {
                type_Name: "-- SELECT --"
            },
            {
                type_Name: "sales"
            },
            {
                type_Name: "recruiter"
            }]
        setType(data);
    }

    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
        }
    }

    const loadsubClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/sub_vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setsubVendorCompanies(data);
        }
    }

    const completeMethodEC = (event: { query: string }) => {
        loadClientCompanies(event.query);
    }

    const completeMethodSubVendor = (event: { query: string }) => {
        loadsubClientCompanies(event.query);
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "companyType") {
                if (value.companyType === "recruiter" && value.companyType != null) {

                    loadTeam(control._formValues.branch, control._formValues.company, "recruiter");
                } else if (value.companyType === "sales" && value.companyType != null) {

                    loadTeam(control._formValues.branch, control._formValues.company, "sales");
                } else {

                    if (value.companyType != null) {
                        loadTeam(control._formValues.branch, control._formValues.company, "");
                    }
                }
            }

            if (name === "company") {
                if (value.company != 0 && value.company != null) {
                    loadTeam(0, value.company);
                    loadSm(0, value.company, 0);
                    loadBranch(value.company);
                } else {
                    if (value.company === 0 && value.company != null) {
                        loadBranch();
                        loadTeam(control._formValues.branch, value.company);
                        loadRecruiters(control._formValues.branch, value.company, control._formValues.team);
                        loadSm(control._formValues.branch, value.company, control._formValues.team);
                    }
                }
            }

            if (name === "branch") {
                if (value.branch != 0 && value.branch != null) {
                    loadTeam(value.branch, 0);
                    loadSm(value.branch, 0, 0);
                    loadRecruiters(value.branch, 0, 0);
                } else {
                    if (value.branch === 0 && value.branch != null) {
                        loadTeam(value.branch, control._formValues.company);
                        loadRecruiters(value.branch, control._formValues.company, control._formValues.team);
                        loadSm(value.branch, control._formValues.company, control._formValues.team);
                    }
                }
            }

            if (name === "team") {
                if (value.team != 0 && value.team != null) {
                    loadSm(0, 0, value.team);
                    loadRecruiters(0, 0, value.team);
                } else {
                    if (value.team === 0 && value.team != null) {
                        loadRecruiters(control._formValues.branch, control._formValues.company, value.team);
                        loadSm(control._formValues.branch, control._formValues.company, value.team);
                    }
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        loadTeam(0, 0);
        loadRecruiters(0, 0, 0);
        loadSm(0, 0, 0);
        loadSubmissionStatus();
        loadType();
        loadBranch();
        loadCompany();
        loadSkillCategories();
    }, []);

    const searchToDB = async (body: IPipelineFilter) => {
        // onHide();
        let filterData: any = body;
        let emptyFilter: any = EmptyFilter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setPLFilter(body);
    }

    function onSubmit(data: IPipelineFilter) {
        if (data.vendor_Company?.vendor_Company_ID) data.vendor_Company_ID = data.vendor_Company?.vendor_Company_ID;
        if (data.subVendor?.vendor_Company_ID) data.subVendorID = data.subVendor?.vendor_Company_ID;
        delete data.vendor_Company;
        delete data.subVendor;
        searchToDB(data);
    }

    // const onHide = () => {
    //     props.hideDialog();
    // }
    const onClear = () => {
        reset(EmptyFilter)
        loadSm(0, 0, 0);
        loadTeam(0, 0, "");
        loadType();
        loadBranch();
        loadCompany();
        loadRecruiters(0, 0, 0);
        loadSkillCategories();
    }

    return (
        // <Dialog visible={props.open} style={{ width: '80vw' }} header="Search Pipeline" modal className="p-fluid" onHide={onHide}>
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" />
            <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="toDate" />
            <JVInput column={6} label="End Client" control={control} name="req_EndClient" />
            <JVDropdownInput column={6} label="Prime Vendor" completeMethod={completeMethodEC} control={control} name="vendor_Company" options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Prime Vendor" />
            <JVDropdownInput column={6} label="Sub Vendor" completeMethod={completeMethodSubVendor} control={control} name="subVendor" options={subVendorCompanies} optionLabel="vendor_Company_Name" placeholder="Search Sub Vendor" />
            <JVInput column={6} label="Req ID" type="number" control={control} name="req_ID" />

            <JVDropdown column={6} label="Type" control={control} name="companyType" options={type} optionLabel="type_Name" optionValue="type_Name" placeholder="Select Type" />
            <JVDropdown column={6} label="Company Name " control={control} name="company" options={company} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company Name" />
            <JVDropdown column={6} label="Branch " control={control} name="branch" options={branch} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch " />
            <JVDropdown column={6} label="Team" control={control} name="team" options={team} optionLabel="team_Name" optionValue="team_ID" placeholder="Select Team" />
            <JVDropdown column={6} label="Sales Manager" control={control} name="sm" options={sm} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Sales" />
            <JVDropdown column={6} label="Recruiter" control={control} name="recruiter_ID" options={recruiters} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Recruiter" />
            <JVDropdown column={6} label="Req Category" control={control} name="req_Category" options={skillCategories} optionLabel="req_CategoryName" optionValue="req_CategoryID" placeholder="Select Req Category" />
            {/* <JVDropdown column={6} label="Status" control={control} name="status_Name" options={submissionStatus} optionLabel="status_Name" optionValue="status_Name" placeholder="Select Status" /> */}
            <div style={{ margin: '10px 0', width: '100%' }}></div>

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={onClear} type="button"></Button>
            </div>
        </form>
    )
}
